module.exports = __webpack_public_path__ + "img/photo-0027.0f89b697.jpg";